import * as THREE from 'three';

export default function useCamera(box, element) {

  // The +2 for width is a fix for a white line on the left in Safari
  const aspect = (element.offsetWidth + 2) / element.offsetHeight;

  const camera = new THREE.PerspectiveCamera(
    45,
    aspect,
    0.1,
    1000,
  );

  // CAMERA POSITIONING AND PARAMS
  // Set camera starting z position based on box dimensions
  camera.position.z = Math.max(box.length, box.width) + (box.length + 5);

  return camera;
}
